import React from 'react';
import PropTypes from 'prop-types';
import { Alert, PageHeader } from 'antd';

const ErrorPage = ({ title, error }) => (
  <PageHeader className="page-main-header" title={title}>
    <Alert
      showIcon
      type="error"
      message={`Error ${error.status || 500}`}
      description={error.message || 'An unexpected error occurred.'}
    />
  </PageHeader>
);

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  error: PropTypes.shape({
    status: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default ErrorPage;
